module.exports = __webpack_public_path__ + "img/reward-subtitle03.315cfd58.png";